import { render, staticRenderFns } from "./OrderSuggestions.vue?vue&type=template&id=fb4f52ee&scoped=true&"
import script from "./OrderSuggestions.vue?vue&type=script&lang=js&"
export * from "./OrderSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./OrderSuggestions.vue?vue&type=style&index=0&id=fb4f52ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4f52ee",
  null
  
)

export default component.exports